import { render, staticRenderFns } from "./special-statistics.vue?vue&type=template&id=0bbf78aa&"
import script from "./special-statistics.vue?vue&type=script&lang=ts&"
export * from "./special-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./special-statistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports